import { Client } from '@microsoft/microsoft-graph-client';
import { NovaOportunidadeForm } from '../components/NovaOportunidadeModal';

const APP_URL = 'https://pipeline-dcm-dti.pages.dev';
const TEAM_ID = '050ad99b-0592-40db-92a9-6cd66b0643ea';
const CHANNEL_ID = '19:orHgY8vQNTKmYz9VR3MrdtNM19GAfFb3in6VI43Kjf41@thread.tacv2';

export async function notifyNewOpportunity(
  client: Client,
  form: NovaOportunidadeForm
): Promise<{ ok: boolean; log: string[] }> {
  const logs: string[] = [];
  try {
    const slaLine = form.dataLimiteParecer
      ? `<tr><td><b>⏱ Data Limite:</b></td><td>${form.dataLimiteParecer}</td></tr>` : '';

    const content = `<p>🆕 <b>Nova Oportunidade — ${form.titulo}</b></p>
<p>Comercial: <b>${form.comercialNome}</b> &nbsp;|&nbsp; Técnico DTI: <b>${form.tecnicoNome || '—'}</b></p>
<table>
<tr><td><b>🏢 Cliente:</b></td><td>${form.cliente}</td></tr>
${slaLine}
<tr><td><b>📝 Âmbito:</b></td><td>${form.ambitoNecessidades}</td></tr>
</table>
<p>🔗 ${APP_URL}</p>`;

    await client
      .api(`/teams/${TEAM_ID}/channels/${CHANNEL_ID}/messages`)
      .post({ body: { contentType: 'html', content } });

    logs.push('✓ Mensagem enviada');
    return { ok: true, log: logs };
  } catch (e: any) {
    logs.push('✗ ' + (e?.message || JSON.stringify(e)));
    console.error('[TeamsNotify]', logs.join('\n'));
    return { ok: false, log: logs };
  }
}
